import {
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY,
  ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS,
  ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO,
  ADS_CAMPAIGN_GET_DIRECTIONS_CALL_TO_ACTION_OPTION,
  ADS_CAMPAIGN_MEDIA_FROM_TIKTOK_POST,
  META,
  TIKTOK,
  VIDEO_FORMATS,
} from "../../../utils/constants";
import { getExtensionFile } from "../../../utils/string";

const FORMATS_META_CAROUSEL = [
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD,
];

const FORMATS_META_INSTAGRAM = [
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD,
];

const FORMATS_META_GET_DIRECTIONS = [
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD,
  ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD,
  ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY,
];

export const getApprovalEntityPlatform = (entity = {}) => {
  return (
    entity?.texts?.[0]?.target?.platform ||
    entity?.creatives?.[0]?.target?.platform ||
    ""
  );
};

export const isApprovalAdPreviewSupported = (entity = {}) => {
  if (entity?.entityType !== "ad") {
    return false;
  }

  const platform = getApprovalEntityPlatform(entity);
  return platform === META || platform === TIKTOK;
};

const getMetaAvailableFormats = ({ isCarousel, callToAction }) => {
  if (isCarousel) {
    return FORMATS_META_CAROUSEL;
  }

  if (callToAction === ADS_CAMPAIGN_GET_DIRECTIONS_CALL_TO_ACTION_OPTION) {
    return FORMATS_META_GET_DIRECTIONS;
  }

  return FORMATS_META_INSTAGRAM;
};

const getTikTokAvailableFormats = ({ mediaFrom, isVideo }) => {
  if (mediaFrom === ADS_CAMPAIGN_MEDIA_FROM_TIKTOK_POST) {
    return [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO];
  }

  return isVideo
    ? [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO]
    : [ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS];
};

export const getAvailableApprovalAdFormats = ({
  platform,
  isCarousel = false,
  callToAction = "",
  mediaUrl = "",
  mediaFrom = "",
}) => {
  if (platform === META) {
    return getMetaAvailableFormats({ isCarousel, callToAction });
  }

  if (platform === TIKTOK) {
    const extension = getExtensionFile(mediaUrl);
    const isVideo = VIDEO_FORMATS.includes(extension);
    return getTikTokAvailableFormats({ mediaFrom, isVideo });
  }

  return [];
};

export const getDefaultApprovalAdFormat = ({
  platform,
  isCarousel = false,
  callToAction = "",
  mediaUrl = "",
  mediaFrom = "",
}) => {
  const formats = getAvailableApprovalAdFormats({
    platform,
    isCarousel,
    callToAction,
    mediaUrl,
    mediaFrom,
  });

  if (formats.length === 0) {
    return "";
  }

  if (platform === META) {
    return ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD;
  }

  if (platform === TIKTOK) {
    return isCarousel
      ? ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS
      : ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO;
  }

  return formats[0];
};
